import React from "react";
import CustomCheckbox from "../../CustomForm/CustomCheckbox";

const AdditionalChecks = ({ formData, handleFormChange }) => {
  const handleCheckboxUpdate = (checked, name) => {
    handleFormChange({
      target: {
        name,
        value: checked,
        type: "checkbox",
        checked,
      },
    });
  };

  return (
    <div
      style={{ padding: "20px", background: "#f5f8ff", borderRadius: "8px" }}
    >
      <h4 style={{ marginBottom: "10px" }}>
        <strong>Additional Checks:</strong>
      </h4>

      <CustomCheckbox
        name="gp_called"
        label="GP Called Out"
        isInitiallyChecked={formData?.gp_called || false}
        onClick={handleCheckboxUpdate}
      />

      <CustomCheckbox
        name="called_999"
        label="Resulted in 999 call"
        isInitiallyChecked={formData?.called_999 || false}
        onClick={handleCheckboxUpdate}
      />

      <CustomCheckbox
        name="hospitalised"
        label="Resulted in Hospitalisation"
        isInitiallyChecked={formData?.hospitalised || false}
        onClick={handleCheckboxUpdate}
      />
    </div>
  );
};

export default AdditionalChecks;
